module.exports = __webpack_public_path__ + "img/checkbox-on.481d8db7.svg";